import type { IconNode } from '../types';

/**
 * @name gap-vertical
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAxMmgyIiAvPgogIDxwYXRoIGQ9Ik04IDEyaDIiIC8+CiAgPHBhdGggZD0iTTE0IDEyaDIiIC8+CiAgPHBhdGggZD0iTTIwIDEyaDIiIC8+CiAgPHBhdGggZD0iTTMgMjF2LTNhMiAyIDAgMCAxIDItMmgxNGEyIDIgMCAwIDEgMiAydjMiIC8+CiAgPHBhdGggZD0iTTMgM3YzYTIgMiAwIDAgMCAyIDJoMTRhMiAyIDAgMCAwIDItMlYzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/gap-vertical
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const GapVertical: IconNode = [
  ['path', { d: 'M2 12h2' }],
  ['path', { d: 'M8 12h2' }],
  ['path', { d: 'M14 12h2' }],
  ['path', { d: 'M20 12h2' }],
  ['path', { d: 'M3 21v-3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3' }],
  ['path', { d: 'M3 3v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3' }],
];

export default GapVertical;
